import React from "react"
import Slider from "react-slick"
import { Container } from "reactstrap"

import Animate from "../animate"

const list = [
  {
    image: "/images/pravo300.png",
    imageWidth: "154px",
    url: "/"
  },
  {
    image: "/images/kommersant.png",
    imageWidth: "300px",
    url: "/"
  },
  {
    image: "/images/rbk.png",
    imageWidth: "218px",
    url: "/"
  }
]

const RatingsSection = ({ title }) => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          variableWidth: true,
          arrows: false
        }
      }
    ]
  }
  return (
    <section className="section section_ratings" id="ratings">
      <Container>
        <h2 className="section_title">{title}</h2>

        <div className="list list--bordered">
          <Slider {...settings} className="slider slider_ratings">
            {list.map((item, i) => (
              <div className="col list_item slider_item" key={i}>
                <Animate className={`fade-in delay-${i + 1}`}>
                  <div
                    className="list_item__link"
                    // target="_blank"
                    // rel="noreferrer noopenner"
                    // href={item.url}
                  >
                    <img
                      src={item.image}
                      alt="rating"
                      width={item.imageWidth}
                    />
                  </div>
                </Animate>
              </div>
            ))}
          </Slider>
        </div>
      </Container>
    </section>
  )
}

export default RatingsSection
